import Evenement from './evenement';
import Calendrier from './calendrier';

export default [...Evenement, ...Calendrier];
